import React from "react";
import { TrendingUp, FileText, Users, Wallet, ArrowUpRight, Receipt, Plus } from "lucide-react";

/* Phone screen #1 — Dashboard with KPIs and tiny chart */
export const ScreenDashboard = () => {
  return (
    <div className="h-full w-full flex flex-col text-slate-100">
      {/* Header */}
      <div className="flex items-center justify-between mb-3">
        <div>
          <div className="text-[9px] text-slate-400 uppercase tracking-wider">Bonjour</div>
          <div className="text-sm font-semibold">Lucas M.</div>
        </div>
        <div className="h-8 w-8 rounded-full bg-gradient-to-br from-blue-500 to-emerald-500 flex items-center justify-center text-[10px] font-bold">LM</div>
      </div>

      {/* Hero KPI card */}
      <div className="rounded-2xl p-3 bg-gradient-to-br from-blue-600/90 via-blue-700/80 to-emerald-700/70 border border-white/10 shadow-lg">
        <div className="flex items-center justify-between">
          <span className="text-[9px] uppercase tracking-wider text-blue-100/90">CA ce mois</span>
          <span className="inline-flex items-center gap-0.5 text-[9px] text-emerald-200 bg-emerald-500/20 px-1.5 py-0.5 rounded-full">
            <ArrowUpRight size={9} /> +18%
          </span>
        </div>
        <div className="mt-1.5 text-2xl font-bold tracking-tight">4 820 €</div>
        {/* mini line chart */}
        <svg viewBox="0 0 120 36" className="w-full h-9 mt-2">
          <defs>
            <linearGradient id="g1" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#fff" stopOpacity="0.5" />
              <stop offset="100%" stopColor="#fff" stopOpacity="0" />
            </linearGradient>
          </defs>
          <path d="M0 28 L15 22 L30 24 L45 14 L60 18 L75 10 L90 14 L105 6 L120 9 L120 36 L0 36 Z" fill="url(#g1)" />
          <path d="M0 28 L15 22 L30 24 L45 14 L60 18 L75 10 L90 14 L105 6 L120 9" stroke="#fff" strokeWidth="1.5" fill="none" strokeLinecap="round" />
        </svg>
      </div>

      {/* Mini stats grid */}
      <div className="grid grid-cols-2 gap-2 mt-3">
        <div className="rounded-xl p-2.5 bg-slate-900/80 border border-white/5">
          <div className="flex items-center gap-1.5 text-[9px] text-slate-400">
            <FileText size={10} className="text-blue-400" /> Factures
          </div>
          <div className="mt-1 text-sm font-semibold">12</div>
          <div className="text-[9px] text-emerald-400">9 payées</div>
        </div>
        <div className="rounded-xl p-2.5 bg-slate-900/80 border border-white/5">
          <div className="flex items-center gap-1.5 text-[9px] text-slate-400">
            <Wallet size={10} className="text-emerald-400" /> Dépenses
          </div>
          <div className="mt-1 text-sm font-semibold">1 240 €</div>
          <div className="text-[9px] text-slate-500">-8% vs mois-1</div>
        </div>
        <div className="rounded-xl p-2.5 bg-slate-900/80 border border-white/5">
          <div className="flex items-center gap-1.5 text-[9px] text-slate-400">
            <Users size={10} className="text-blue-400" /> Clients
          </div>
          <div className="mt-1 text-sm font-semibold">28</div>
          <div className="text-[9px] text-blue-300">+3 nouveaux</div>
        </div>
        <div className="rounded-xl p-2.5 bg-slate-900/80 border border-white/5">
          <div className="flex items-center gap-1.5 text-[9px] text-slate-400">
            <TrendingUp size={10} className="text-emerald-400" /> Marge
          </div>
          <div className="mt-1 text-sm font-semibold">74%</div>
          <div className="text-[9px] text-emerald-400">Très bonne</div>
        </div>
      </div>

      {/* Recent activity */}
      <div className="mt-3 rounded-xl bg-slate-900/80 border border-white/5 p-2.5 flex-1 overflow-hidden">
        <div className="flex items-center justify-between mb-1.5">
          <span className="text-[10px] font-semibold text-slate-200">Activité récente</span>
          <span className="text-[9px] text-blue-400">Voir tout</span>
        </div>
        {[
          { name: "Facture #2041", sub: "Atelier Durand", val: "+580 €", c: "text-emerald-400" },
          { name: "Carburant", sub: "Total Energies", val: "-62 €", c: "text-slate-300" },
          { name: "Facture #2040", sub: "SARL Léon", val: "+1 240 €", c: "text-emerald-400" },
        ].map((r, i) => (
          <div key={i} className="flex items-center justify-between py-1.5 border-t border-white/5 first:border-0">
            <div className="flex items-center gap-2">
              <div className="h-6 w-6 rounded-md bg-slate-800 border border-white/5 flex items-center justify-center">
                <Receipt size={10} className="text-blue-400" />
              </div>
              <div>
                <div className="text-[10px] font-medium text-slate-100">{r.name}</div>
                <div className="text-[9px] text-slate-500">{r.sub}</div>
              </div>
            </div>
            <span className={`text-[10px] font-semibold ${r.c}`}>{r.val}</span>
          </div>
        ))}
      </div>

      {/* Tab bar */}
      <div className="mt-2 rounded-xl bg-slate-900/90 border border-white/5 px-3 py-2 flex items-center justify-between">
        <div className="text-blue-400 text-[10px] font-semibold">Accueil</div>
        <div className="text-slate-500 text-[10px]">Clients</div>
        <div className="h-7 w-7 rounded-full bg-gradient-to-br from-blue-500 to-emerald-400 flex items-center justify-center">
          <Plus size={12} />
        </div>
        <div className="text-slate-500 text-[10px]">Factures</div>
        <div className="text-slate-500 text-[10px]">Plus</div>
      </div>
    </div>
  );
};

/* Phone screen #2 — Invoices list */
export const ScreenInvoices = () => {
  return (
    <div className="h-full w-full flex flex-col text-slate-100">
      <div className="flex items-center justify-between mb-3">
        <div>
          <div className="text-[9px] text-slate-400 uppercase tracking-wider">Documents</div>
          <div className="text-sm font-semibold">Factures</div>
        </div>
        <div className="h-7 w-7 rounded-full bg-blue-500 flex items-center justify-center">
          <Plus size={12} />
        </div>
      </div>

      <div className="rounded-xl bg-slate-900/80 border border-white/5 p-2.5 mb-2">
        <div className="text-[9px] text-slate-400">Total impayé</div>
        <div className="text-lg font-bold text-amber-300">920 €</div>
        <div className="mt-1 h-1.5 w-full rounded-full bg-slate-800 overflow-hidden">
          <div className="h-full w-3/4 bg-gradient-to-r from-blue-500 to-emerald-400" />
        </div>
        <div className="text-[9px] text-slate-500 mt-1">75% encaissé ce mois</div>
      </div>

      <div className="flex-1 rounded-xl bg-slate-900/80 border border-white/5 p-2 overflow-hidden">
        {[
          { id: "#2042", c: "Atelier Durand", s: "Payée", color: "text-emerald-300 bg-emerald-500/15", amt: "580 €" },
          { id: "#2041", c: "SARL Léon", s: "En attente", color: "text-amber-300 bg-amber-500/15", amt: "1 240 €" },
          { id: "#2040", c: "M. Petit", s: "Payée", color: "text-emerald-300 bg-emerald-500/15", amt: "320 €" },
          { id: "#2039", c: "B. Lambert", s: "Brouillon", color: "text-slate-300 bg-slate-700/40", amt: "—" },
          { id: "#2038", c: "Cabinet R.", s: "Payée", color: "text-emerald-300 bg-emerald-500/15", amt: "1 080 €" },
        ].map((f, i) => (
          <div key={i} className="flex items-center justify-between py-2 border-t border-white/5 first:border-0">
            <div>
              <div className="text-[10px] font-medium">{f.id} · {f.c}</div>
              <span className={`inline-block mt-0.5 text-[8px] px-1.5 py-0.5 rounded-full ${f.color}`}>{f.s}</span>
            </div>
            <div className="text-[10px] font-semibold">{f.amt}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

/* Phone screen #3 — Clients list */
export const ScreenClients = () => {
  const clients = [
    { name: "Atelier Durand", tag: "Pro", color: "from-blue-500 to-cyan-400", val: "4 facts" },
    { name: "SARL Léon", tag: "VIP", color: "from-emerald-500 to-teal-400", val: "12 facts" },
    { name: "M. Petit", tag: "Part.", color: "from-indigo-500 to-blue-400", val: "2 facts" },
    { name: "Cabinet R.", tag: "Pro", color: "from-sky-500 to-blue-400", val: "7 facts" },
    { name: "B. Lambert", tag: "Part.", color: "from-blue-600 to-emerald-500", val: "1 fact" },
    { name: "Ferme V.", tag: "Pro", color: "from-teal-500 to-emerald-400", val: "9 facts" },
  ];
  return (
    <div className="h-full w-full flex flex-col text-slate-100">
      <div className="flex items-center justify-between mb-3">
        <div>
          <div className="text-[9px] text-slate-400 uppercase tracking-wider">Carnet</div>
          <div className="text-sm font-semibold">Clients</div>
        </div>
        <div className="h-7 w-7 rounded-full bg-blue-500 flex items-center justify-center">
          <Plus size={12} />
        </div>
      </div>
      <div className="rounded-xl bg-slate-900/80 border border-white/5 px-2.5 py-1.5 text-[10px] text-slate-400 mb-2">
        Rechercher un client…
      </div>
      <div className="flex-1 rounded-xl bg-slate-900/80 border border-white/5 p-2 overflow-hidden">
        {clients.map((c, i) => (
          <div key={i} className="flex items-center gap-2 py-2 border-t border-white/5 first:border-0">
            <div className={`h-7 w-7 rounded-full bg-gradient-to-br ${c.color} flex items-center justify-center text-[10px] font-bold`}>
              {c.name.slice(0, 1)}
            </div>
            <div className="flex-1">
              <div className="text-[10px] font-medium">{c.name}</div>
              <div className="text-[9px] text-slate-500">{c.val}</div>
            </div>
            <span className="text-[8px] uppercase px-1.5 py-0.5 rounded-full bg-slate-800 border border-white/5 text-slate-300">{c.tag}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
